(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    (function() {
    function luxTdsPhStorageKey(details) {
      const vp = details && details.closest && details.closest('variant-picker');
      const pid = vp && vp.dataset ? vp.dataset.productId : null;
      const idx = details && details.dataset ? details.dataset.tdsOptionIndex : null;
      if (pid == null || idx == null) return null;
      return 'lux-tds-ph-dismissed-' + pid + '-' + idx;
    }

    function luxTdsPhRestoreDismissed(details) {
      if (!details || details.dataset.forcePlaceholder !== 'true') return;
      const key = luxTdsPhStorageKey(details);
      if (!key) return;
      try {
        if (window.sessionStorage.getItem(key) === '1') {
          details.dataset.placeholderDismissed = 'true';
        }
      } catch (e) {}
    }

    function luxTdsPhPersistDismissed(details) {
      if (!details || details.dataset.forcePlaceholder !== 'true') return;
      const key = luxTdsPhStorageKey(details);
      if (!key) return;
      try {
        window.sessionStorage.setItem(key, '1');
      } catch (e) {}
    }

    function syncTdsSelect(select) {
      const details = select.closest('.variant-option--tds-compact');
      if (!details) return;
      luxTdsPhRestoreDismissed(details);
      const row = details.querySelector('.variant-option--tds__row');
      const middle = row?.querySelector('.variant-option--tds__middle');
      const placeholder = row?.querySelector('[data-tds-placeholder]');
      const valueEl = row?.querySelector('[data-tds-value]');
      if (!middle || !valueEl) return;
      const placeHolderText = select.dataset.placeholder || 'SELECT';
      const sel = select.options[select.selectedIndex];
      const forcePh = details.dataset.forcePlaceholder === 'true';
      const dismissed = details.dataset.placeholderDismissed === 'true';
      const list = details?.querySelector('.variant-option--tds__list');
      if (list) {
        const selVal = sel?.value || '';
        list.querySelectorAll('.variant-option--tds__item').forEach(function(el) {
          const itemVal = el.getAttribute('data-value') || '';
          const isSel = itemVal === selVal;
          el.classList.toggle('variant-option--tds__item--selected', isSel);
          el.setAttribute('aria-selected', isSel);
        });
      }
      if (forcePh && !dismissed && sel && sel.value) {
        valueEl.textContent = '';
        middle.classList.remove('has-value');
        if (placeholder) placeholder.textContent = placeHolderText;
        return;
      }
      if (sel && sel.value) {
        valueEl.textContent = sel.text.split(' – ')[0].split(' - ')[0].trim();
        middle.classList.add('has-value');
      } else {
        valueEl.textContent = '';
        middle.classList.remove('has-value');
        if (placeholder) placeholder.textContent = placeHolderText;
      }
    }
    function init() {
      document.querySelectorAll('[data-tds-select]').forEach(function(select) {
        if (select.dataset.tdsSyncBound === 'true') return;
        select.dataset.tdsSyncBound = 'true';
        syncTdsSelect(select);
        select.addEventListener('change', function() {
          const details = select.closest('.variant-option--tds-compact');
          if (details && details.dataset.forcePlaceholder === 'true') {
            details.dataset.placeholderDismissed = 'true';
            luxTdsPhPersistDismissed(details);
          }
          syncTdsSelect(select);
        });
      });
      document.querySelectorAll('.variant-option--tds__item').forEach(function(btn) {
        if (btn.dataset.tdsItemBound === 'true') return;
        if (btn.disabled) return;
        btn.dataset.tdsItemBound = 'true';
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          const details = btn.closest('.variant-option--tds-compact');
          const select = details?.querySelector('[data-tds-select]');
          if (!select) return;
          const val = btn.getAttribute('data-value');
          if (val == null || val === '') return;
          const opt = Array.from(select.options).find(function(o) {
            return o.value === val;
          });
          if (!opt) return;
          if (details && details.dataset.forcePlaceholder === 'true') {
            details.dataset.placeholderDismissed = 'true';
            luxTdsPhPersistDismissed(details);
          }
          select.value = val;
          select.selectedIndex = opt.index;
          syncTdsSelect(select);
          details.removeAttribute('open');
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
    function onLoad() {
      init();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onLoad);
    } else {
      onLoad();
    }
    document.addEventListener('variant:update', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
